(ns hai.ui.components.hover-popover
  "How a popover over a small control opens and closes: hovering the control
   opens it after a beat, and leaving control and popover alike closes it after
   one, long enough to cross from one to the other. Touch has no hover, so a
   tap opens it, and its ✕ closes it. A Radix Popover rather than a HoverCard,
   whose trigger prevents touchstart's default — refused in React's passive
   listener, and logged. Used by [[hai.entity.related]]."
  (:require
   [reagent.core :as r]))

(def ^:private open-delay-ms 200)
(def ^:private close-delay-ms 150)

(defn- touch? [e]
  (= "touch" (.-pointerType e)))

(defn controls
  "The open flag and handlers for one popover, made once in a `r/with-let`
   whose `finally` calls `dispose!`. `on-enter` and `on-leave` go on both the
   trigger and the popover content; `open!` on the trigger's click; `close!` on
   the ✕ and on the Root's `onOpenChange` closing it."
  []
  (let [!open? (r/atom false)
        !timer (atom nil)
        set-open! (fn [open?]
                    (some-> @!timer js/clearTimeout)
                    (reset! !open? open?))
        set-open-later! (fn [open? delay-ms]
                          (some-> @!timer js/clearTimeout)
                          (reset! !timer (js/setTimeout #(reset! !open? open?) delay-ms)))]
    {:!open? !open?
     :open! #(set-open! true)
     :close! #(set-open! false)
     :on-enter (fn [e]
                 (when-not (touch? e)
                   (set-open-later! true open-delay-ms)))
     :on-leave (fn [e]
                 (when-not (touch? e)
                   (set-open-later! false close-delay-ms)))
     :dispose! #(some-> @!timer js/clearTimeout)}))
